import { defaultStepPropertyTypeListEnum, generalStepPropertyTypeListEnum } from 'assets/constants';

export function moveItemInArray<T>(list: Array<T>, from: number, to: number) {
  list.splice(to, 0, list.splice(from, 1)[0]);
}

export function makeSortByKeyFn<T>(key: keyof T) {
  return (a: T, b: T) => {
    const anull = a == null || Number.isNaN(a);
    const bnull = b == null || Number.isNaN(b);

    if (anull && bnull) return 0;
    if (anull) return -1;
    if (bnull) return 1;

    const aval = a[key];
    const bval = b[key];

    const avalnull = aval == null || Number.isNaN(aval);
    const bvalnull = bval == null || Number.isNaN(bval);

    if (avalnull && bvalnull) return 0;
    if (avalnull) return -1;
    if (bvalnull) return 1;

    return aval > bval
      ? 1
      : aval < bval
        ? -1
        : 0;
  };
}

export function makeSortByKey<T>(key: keyof T) {
  const sortFn = makeSortByKeyFn<any>(key);

  return <I>(items: I[]) => items
    .slice()
    .sort(sortFn);
}
/* @ts-ignore */
export const filterOutObject = (list, key, value) => {
  /* @ts-ignore */
  const [variable1, variable2] = list.reduce(([matches, others], obj) =>
    obj[key] === value ? [[...matches, obj], others] : [matches, [...others, obj]],
    [[], []]);

  return [variable1[0], variable2];
};

//function that returns 3 arrays, 0 and 2 are general widgets and 1 is main step properties
export function separateWidgetsAndProperties(array) {

  let index = 0;
  let mainWidgets = false;

  const properties = array?.reduce((properties, property) => {

    if (!!generalStepPropertyTypeListEnum[property.type] && mainWidgets) {
      index = 2;

    } else if (!generalStepPropertyTypeListEnum[property.type]) {
      mainWidgets = true;
      index = 1;
    }
    properties[index].push({ propertyId: property.propertyId, type: property.type, value: property.value, visible: property.visible })
    return properties;
  }, [[], [], []])

  return properties;
}

export function findProperty(properties, typeToFind) {
  return properties?.find(({ type }) => type === typeToFind)?.value;
}

export function findVisibility(properties, typeToFind) {
  return properties?.find(({ type }) => type === typeToFind)?.visible;
}

export function checkTypeAndShowAllQuestions(data) {
  return data?.some(item => item.type === defaultStepPropertyTypeListEnum.defaultQuestion
    && item.value.showAllQuestions === true);
}

export function stepsIndicatorsArrayToObject(array) {
  return array.reduce((acc, val) => {
    acc[val] = true;
    return acc;
  }, {})
}

export function filterPropertyWithoutType(inputArray, typeToRemove) {
  return inputArray.filter(item => item.type !== typeToRemove);
}

export function stepHasMissingData(obj, index) {
  return !obj || !obj[index] || !Object.values(obj[index])[0];
}
